export const API_ROOT =
  process.env.REACT_APP_API_ROOT ||
  process.env.REACT_APP_API_V2_ROOT ||
  'https://api.worldcovr.com';
export const MAGIC_API_KEY = process.env.REACT_APP_MAGIC_API_KEY || 'pk_test_F22052A660580DB8';
export const MAPBOX_TOKEN =
  process.env.REACT_APP_MAPBOX_TOKENN ||
  'pk.eyJ1IjoiamFzb25zY2hhcGlybyIsImEiOiJjazNlcnJpbXUwMWRzM2VtbDhpcTdxemN3In0.PVLZkH91kDLHYqq2g45Y5g';
